import { AuditSchedule } from '@mi-front/core';
import { MrtTable } from '@mi-front/ui';
import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';
import { FormattedMessage, useIntl } from 'react-intl';
import { LDate } from '../../../../../../components/date/LDate';
import { LTime } from '../../../../../../components/date/LTime';
import { RowAction } from '../../../../../../components/table/RowAction';
import { RowActions } from '../../../../../../components/table/RowActions';
import { ListingResultProps } from '../../../../../../core/reports/components/ListingView';
import { useActiveStation } from '../../../../../../core/stations/hooks/useActiveStation';
import { AuditMediaPlayerAction } from '../../../../components/AuditMediaPlayerAction';
import { NoAudioIndicator } from '../../../../components/schedule/NoAudioIndicator';
import { ScheduleMatchStatus } from '../../../../components/schedule/ScheduleMatchStatus';
import { ScheduleTolerance } from '../../../../components/schedule/ScheduleTolerance';
import { SchedulesMentionsListing } from '../mentions/SchedulesMentionsListView';

export function SchedulesListSpotResult(p: ListingResultProps<SchedulesMentionsListing>) {
  const { $t } = useIntl();
  const station = useActiveStation();

  const viewScheduleUrlFn = (schedule: AuditSchedule) =>
    `/audit/s/${station.slug}/schedule/spot/${schedule.id}`;

  return (
    <MrtTable
      {...p.mrtProps}
      columns={[
        {
          header: $t({
            id: 'audit.props.datetime',
            defaultMessage: 'Fecha y hora programada',
          }),
          accessorKey: 'datetime',
          Cell: ({ row }) => (
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <LDate value={row.original.datetime} day="2-digit" month="2-digit" year="2-digit" />
              <LTime value={row.original.datetime} />
            </div>
          ),
          size: 300,
        },
        {
          header: $t({
            id: 'audit.props.customAudioId',
            defaultMessage: 'ID media',
          }),
          accessorKey: 'customId',
          size: 200,
        },
        {
          header: $t({
            id: 'audit.props.tolerance',
            defaultMessage: 'Tolerancia (mins)',
          }),
          Cell: ({ row }) => <ScheduleTolerance config={row.original.toleranceConfig} />,
          size: 150,
        },
        {
          header: $t({
            id: 'audit.schedulesListScreen.props.status',
            defaultMessage: 'Estado',
          }),
          Cell: ({ row }) => {
            if (!row.original.audio) {
              return <NoAudioIndicator />;
            }

            return <ScheduleMatchStatus schedule={row.original} />;
          },
        },
        {
          header: $t({
            id: 'common.text.actions',
            defaultMessage: 'Acciones',
          }),
          Cell: ({ row }) => (
            <RowActions>
              <RowAction
                title={
                  <FormattedMessage
                    id="audit.schedulesListScreen.viewScheduleBtn"
                    defaultMessage="Ver detalle"
                  />
                }
                link={viewScheduleUrlFn(row.original)}
                icon={<OpenInNewIcon />}
              />

              {row.original.audio && (
                <AuditMediaPlayerAction
                  audio={{
                    ...row.original.audio,
                    stationId: station.id,
                  }}
                />
              )}
            </RowActions>
          ),
        },
      ]}
    />
  );
}
